import { atom } from 'jotai'

// Loading state atom
export const loadingAtom = atom(false)

// Form data persistence atom
export const formDataAtom = atom({})

// Success state atom
export const successAtom = atom(false)